import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { GoogleTagConfig, RuntimeConfig } from '@common/util-models';
import { RUNTIME_CONFIG } from '@common/util-foundation';
import { AoReinstateFeatureShellModule } from '@ao-reinstate/feature-shell';
import { environment } from '@ao-reinstate/util-environment';
import { AppComponent } from './app.component';
import { COMPONENT_MAPPING } from './cms-config/cms-component-mapping.config';
import { cmsDataUrl } from './cms-config/cms-data-url';
import { POSTHOG_CONFIG } from '@tracking/posthog/posthog-config.token';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AoReinstateFeatureShellModule.forRoot({
      componentMapping: COMPONENT_MAPPING,
      gaTagsConfig: ({} as unknown) as GoogleTagConfig,
      cmsDataUrl,
    }),
  ],
  providers: [
    { provide: 'isDevelopmentEnvironment', useValue: !environment.production }, // to enable debug logger
    {
      provide: POSTHOG_CONFIG,
      useFactory: (runtimeConfig: RuntimeConfig) => ({
        apiKey: runtimeConfig.posthog?.key,
        apiHost: runtimeConfig.posthog?.host,
        personProfiles: true,
        debug: !environment.production,
      }),
      deps: [RUNTIME_CONFIG],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
